import type { LiveStatus } from "../lib/hooks/useLiveUpdates";

interface Props {
  status: LiveStatus;
}

export function LiveIndicator({ status }: Props) {
  const cls =
    status === "open"
      ? "jarvis-presence"
      : status === "connecting"
        ? "jarvis-presence is-signal"
        : "jarvis-presence is-idle";
  const label =
    status === "open"
      ? "Live"
      : status === "connecting"
        ? "Reconnecting…"
        : "Offline";
  return (
    <span className={cls} title={label}>
      <span className="dot" />
      {label}
    </span>
  );
}
